module.exports = __webpack_public_path__ + "img/smart_snap.390e7ee3.png";